import FilterBenefitsCheckboxes from './FilterBenefitsCheckboxes'

export default FilterBenefitsCheckboxes
